import React, { useEffect, useState } from "react";
import { staticURLs } from "../../config/urls";
import * as Service from "../../store/service";

const GettingStarted = (props: any) => {
    const [showGettingStarted, setShowGettingStarted] = useState(false);

    const hide = () => {
        setShowGettingStarted(false);
        Service.setShowGettingStarted();
    };

    const getShowGettingStarted = () => {
        Service.getShowGettingStarted().then((data) => {
            setShowGettingStarted(data);
        });
    };

    useEffect(() => {
        getShowGettingStarted();
    }, []);

    return (
        <React.Fragment>
            {showGettingStarted && (
                <div className="box">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-text has-actions">
                                <h2 className="box-title">Getting Started</h2>
                            </div>
                        </div>
                        <div className="box-actions">
                            <a href="javascript:void(0);" onClick={hide} className="default_link">
                                Hide
                            </a>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="row">
                            {/* <div className="col-xs-12 col-sm-6 col-md-5"> */}
                            {/* <video controls>*/}
                            {/* <source src={staticURLs.RepIQGettingStarted} type="video/mp4" />*/}
                            {/*</video>*/}
                            {/* <iframe src={staticURLs.RepIQGettingStarted} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
                            {/* <a href="javascript:void(0);" className="image-link" title="Watch the video"><img src="images/img_placeholder.jpg" alt="Placeholder" /></a>*/}
                            {/* </div> */}
                            {/* <div className="col-xs-12 col-sm-6 col-md-7"> */}
                            <h3 className="content-sub-title">Discover how your online content reflects you</h3>
                            <p>
                                Our online reputations are an important component of our personal identities. What does the content you post online communicate to
                                others about your personality? We provide you with this insight to give you more awareness and control over your online reputation.
                                Connect your social media accounts and other online self-published materials to get immediate analysis of key personality attributes
                                and interaction styles reflected by your virtual content.
                            </p>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};
export default GettingStarted;
